import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import Field, { FieldProperties } from "./Field";

class FirstNameField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customGridProperties: {
        cellClass: ["cursor-pointer"],
      },
      features: [
        FieldFeature.SORTABLE,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.REQUIRED,
        FieldFeature.HISTORY_FIELD,
        FieldFeature.EMAIL_DYNAMIC_VARIABLE,
        FieldFeature.SUPPORTS_UNIQUENESS,
      ],
      formProperties: {
        fullWidth: true,
      },
      importProperties: { required: true },
      type: FieldType.STRING,
      ...data,
    });
  }

  get isReadable() {
    // system-required fields are always readable, except Name which can be masked
    return this._schemaDetails?.accessStatus.read !== false;
  }

  get doesSupportPhi() {
    return true;
  }
}

export default FirstNameField;
